import { defineStore } from "pinia";

const MAX_TOASTS = 5;
let counter = 0;

export const useUiStore = defineStore("ui", {
  state: () => ({
    toasts: [],
    breadcrumb: null,
  }),
  actions: {
    setSnackbar(snackbar = {}) {
      counter += 1;

      const toast = {
        id: counter,
        text: snackbar.text || "",
        color: snackbar.color || "success",
        timeout: snackbar.timeout != null ? snackbar.timeout : 10000,
        actionText: snackbar.actionText || null,
        action: snackbar.action || null,
      };

      this.toasts = [...this.toasts, toast].slice(-MAX_TOASTS);
    },
    setBreadcrumb(breadcrumb) {
      this.breadcrumb = breadcrumb;
    },
    dismissToast(id) {
      this.toasts = this.toasts.filter(toast => toast.id !== id);
    },
  },
});

export function setSnackbar(payload) {
  return useUiStore().setSnackbar(payload);
}
